// 三方登陆、授权登陆
import {
  getLocalStorage,
  getSesStorage,
  setSesStorage,
  removeSesStorage,
} from "@/lobby_common/utils/auth";
import Store from "@/lobby_common/store/index";
import Bus from "./bus.js";
import { encode } from "js-base64";
import { ParticleNetwork } from "@particle-network/auth"; // 粒子网络
import { getDeviceInfo, aesEntry } from "@/lobby_common/utils/utils";
// import { MetaMaskSDK } from "@metamask/sdk";
import { Ethereum } from '@particle-network/chains';
// import { ParticleConnect, walletconnect } from '@particle-network/connect';

let vm = null;
export function sendAuthThis(_this) {
  vm = _this;
}

// metamask授权登录PC
export const metamaskLogin = async (obj) => {
  console.log(obj, "objobjobjobjobj");
  const { address, message, signature } = obj;
  console.log("metamaskLogin", address, encode(address));
  if (!address) return;

  const data = {
    params: JSON.stringify({
      applicationId: Store.getters.getPacketConfig?.appConfig?.sid,
      address,
      message,
      signature,
      app: "web",
    }),
    loginType: "THIRD_LOGIN_TYPE_METAMASK",
    loginTypeStr: "metamask",
    inviteCode: getLocalStorage("inviteCode") || "",
    coinCode: Store.getters.getPacketConfig?.appConfig?.coinCode,
  };
  Store.dispatch("thirdLoginAction", { data });
};

// telegram 授权
export const telegramLoginAuth = (callback, item) => {
  // console.log("telegramLoginClick");
  // 这里唯一要做的就是把你机器人参数传入进去（获取机器人token哪里可以看到）
  Bus.$emit("setLoadingType", item.type);
  window.Telegram?.Login?.auth(
    { bot_id: window.telegram_key, request_access: "write", embed: 1 },
    (data) => {
      console.log(data, "这是Telegram回调数据"); // 这里的data和之前返回的user数据和格式无差异
      Bus.$emit("setLoadingType", "");
      if (!data) {
        // 失败时你需要做的逻辑
      }
      // 电报登录成功你需要做的逻辑（这里我是直接写了一个函数去调用登录成功后的业务逻辑）
      callback?.(data);
    }
  );
};

// telegram 登陆
export const telegramLogin = async (opt) => {
  console.log("googleCallbackFun", opt);
  if (!opt.hash) return;
  let params = "";
  Object.keys(opt).map((key, index) => {
    const str = index === 0 ? "" : "&";
    params += str + key + "=" + opt[key];
  });
  const data = {
    params,
    loginType: "THIRD_LOGIN_TYPE_TELEGRAM",
    loginTypeStr: "telegram",
    inviteCode: getLocalStorage("inviteCode") || "",
    coinCode: Store.getters.getPacketConfig?.appConfig?.coinCode,
  };
  Store.dispatch("thirdLoginAction", { data });
};

// 粒子网络授权登陆 https://developers.particle.network/api-reference/wallet/desktop/web
export let particle = null;
let particleNum = false;
// 初始化sdk
export const initParticle = async (params) => {
  // let appId = '9e738afb-41cf-454f-9992-4a5037238a18'
  // let projectId = 'a0971f12-e16d-4f28-a82f-905ae460cbc6'
  // let clientKey = 'cfECgQxKaiNgwtiG5GFZ2GsKcoShKW18xk2xkfP1'
  const { projectId, clientKey, appId } = params;
  // 初始化 Particle Auth
  try {
    particle = new ParticleNetwork({
      projectId,
      clientKey,
      appId,
    });
  } catch (error) {
    console.log('particle',3333)
    console.log("particle配置缺失", error);
  }
};

// 粒子网络授权登陆connect https://github.com/Particle-Network/particle-web-demo/blob/master/packages/vue-vite-starter/src/App.vue
export let connectKit = null;
export let provider = null;
let connectKitNum = false;
// 初始化sdk
export const initConnectKit = async (params) => {
  const { projectId, clientKey, appId, walletconnectId } = params;
  // 初始化 Particle Auth
  try {
    let config = {
      projectId,
      clientKey,
      appId,
    }
    if (walletconnectId) {
      config = {
        ...config,
        chains: [Ethereum],
        wallets: [
          walletconnect({ id: 'walletconnect_v2', projectId: walletconnectId, showQrModal: true, qrModalOptions: { enableExplorer: false } }),
        ],
      }
    }
    connectKit = new ParticleConnect(config);
  } catch (error) {
    console.log('particle',3333)
    console.log("particle配置缺失", error);
  }
};
// 粒子网络授权
// type-社交: google、apple、facebook、twitter、linkedin、discord
// type-钱包：walletconnect_v2
export const loginWithParticle = async (type) => {
  if (particle) {
    try {
      let params = { preferredAuthType: type }
      console.log('loginWithParticle', type, params)
      const userInfo = await particle.auth.login(params);
      console.log("particle登录成功", userInfo);
      return userInfo;
    } catch (error) {
      console.log("particle登录失败", error);
      throw error;
    }
  }
};
export let particleWalletMap = {
  walletconnect: 'walletconnect_v2',
}
export const loginWithConnectKit = async (type) => {
  if (connectKit) {
    try {
      let id = 'particle'
      let options = { preferredAuthType: type }
      let userInfo = null

      if (particleWalletMap[type]) {
        id = particleWalletMap[type] === true ? type : particleWalletMap[type]
        options = {}
      }

      console.log('loginWithConnectKit', connectKit, id, options)
      provider = await connectKit.connect(id, options);
      console.log('loginWithConnectKit', provider)
      if (particleWalletMap[type]) {
          // 获取连接信息
        const accounts = await provider.request({ method: 'eth_accounts' });
        console.log(accounts)
        userInfo = { wallet_address: accounts[0] };
        setSesStorage('connectKitProviderId', id)
      } else {
        userInfo = await provider.auth.login({ preferredAuthType: type })
      }
      
      console.log("particle登录成功", userInfo);
      return userInfo;
    } catch (error) {
      console.log("particle登录失败", error);
      // throw error;
    }
  }
};
// 粒子网络断开钱包函数
export const disconnectWallet = async () => {
  try {
    let connectKitProviderId = getSesStorage('connectKitProviderId')
    console.log('999000', provider, connectKitProviderId)
    if (provider || connectKitProviderId) {
      if (!provider) {
        provider = await connectKit.connect(connectKitProviderId, {});
      }
      await provider.disconnect?.();
      provider = null;
      if (connectKitProviderId) {
        removeSesStorage('connectKitProviderId')
      }
      console.log("断开成功");
    }
  } catch (error) {
    console.log("断开失败", error);
  }
};
// 粒子网络三方登陆
export const loginWithParticleFun = async (item) => {
  console.log("loginthis", item);
  try {
    Bus.$emit("setLoadingType", item.type);
    const userInfo = await loginWithParticle(item.type);
    // const userInfo = await loginWithConnectKit(item.type);
    if (!userInfo) {
      Bus.$emit("setLoadingType", "");
      return;
    }
    const data = {
      params: JSON.stringify({ ...userInfo, third_name: item.type }),
      loginType: "THIRD_LOGIN_TYPE_PARTICLE_NETWORK",
      loginTypeStr: "particle_network",
      inviteCode: getLocalStorage("inviteCode") || "",
      coinCode: Store.getters.getPacketConfig?.appConfig?.coinCode,
    };
    await Store.dispatch("thirdLoginAction", { data });
  } catch (error) {
    console.log(error, "error");
  } finally {
    Bus.$emit("setLoadingType", "");
  }
};
// 快速登陆 一键登陆
export const quickLogin = async (item) => {
  console.log("loginthis", item);
  try {
    Bus.$emit("setLoadingType", item.type);
    const data = {
      params: JSON.stringify({ ...getDeviceInfo() }),
      loginType: "THIRD_LOGIN_TYPE_QUICK_LOGIN",
      loginTypeStr: "quick_login",
      inviteCode: getLocalStorage("inviteCode") || "",
      coinCode: Store.getters.getPacketConfig?.appConfig?.coinCode,
    };
    await Store.dispatch("thirdLoginAction", { data });
  } catch (error) {
    console.log(error, "error");
  } finally {
    Bus.$emit("setLoadingType", "");
  }
};

let isRequestingAccounts = false;
// 小狐狸 metamask
export const metamaskAuth = async (callback, item) => {
  if (!window.ethereum) {
    // 未安裝 MetaMask
    Bus.$emit("showLoginOtherWallet", {
      show: true,
      type: "Metamask",
    });
    return;
  }
  if (isRequestingAccounts) {
    console.log("mmm0 Already requesting accounts");
    return;
  }
  // MetaMask 已安装
  setTimeout(async () => {
    try {
      isRequestingAccounts = true;
      Bus.$emit("setLoadingType", item.type);
      // MetaMask 已安装
      console.log("mmm1", MMSDK);
      if (!MMSDK) {
        MMSDK = await initMetamask();
      }

      // 设置一个计时器，假设 10 秒内用户没有响应
      const requestTimeout = setTimeout(() => {
        console.log("Popup likely closed. No response after 10 seconds.");
        // 在这里可以重置 UI 或其他提示操作
        isRequestingAccounts = false;
        Bus.$emit("setLoadingType", "");
      }, 10000); // 超时10秒

      console.log("mmm2", MMSDK);
      const ethereum = MMSDK?.getProvider();
      console.log("mmm3", ethereum);
      ethereum.on("accountsChanged", (accounts) => {
        console.log("Accounts changed:", accounts);
      });
      const accounts = await ethereum.request({
        method: "eth_requestAccounts",
      });
      console.log("mmm4", ethereum, accounts);

      // 成功请求后清除计时器
      clearTimeout(requestTimeout);

      // 用户已授权，accounts 是用户的以太坊账户数组
      const userAccount = accounts[0];
      // 进行后续的操作，比如展示登录成功提示或者执行其他逻辑
      console.log("用户已授权，账户地址：", userAccount);

      if (vm.$store?.getters?.getIsMobile) {
        const access_token = await aesEntry(Date.now() + "" + userAccount);
        callback({
          address: access_token,
          message: "",
          signature: "",
        });
      } else {
        // 签名
        const message = "account";
        const sign = await window.ethereum.request({
          method: "personal_sign",
          params: [message, userAccount],
        });
        callback({
          address: userAccount,
          message: "",
          signature: sign,
        });
      }
    } catch (error) {
      // 用户拒绝授权或发生其他错误
      console.log("用户未授权或发生错误:", error);
    } finally {
      console.log("mmm5", 1111);
      isRequestingAccounts = false;
      Bus.$emit("setLoadingType", "");
    }
  }, 200);
};

export let MMSDK = null;
// 小狐狸初始化
export const initMetamask = async () => {
  // MMSDK = new MetaMaskSDK({
  //   extensionOnly: true,
  //   i18nOptions: {
  //     enabled: true,
  //   },
  // });
  // return MMSDK;
};

// 三方授权统一方法
export const thirdAuth = async (item, callback) => {
  let info = null;
  // 粒子网络
  if (item.loginType === "particle_network") {
    const type = item.type || item.loginSubType;
    // info = await loginWithConnectKit(type);
    info = await loginWithParticle(type);
  }
  // telegram
  if (item.loginType === "telegram") {
    telegramLoginAuth((opt)=> {
      let params = "";
      Object.keys(opt).map((key, index) => {
        const str = index === 0 ? "" : "&";
        params += str + key + "=" + opt[key];
      });
      callback(params)
    }, item);
    return;
  }
  // metamask
  if (item.loginType === "metamask") {
  
    metamaskAuth((opt) =>{
      const { address, message, signature } = opt;
      let params = JSON.stringify({
        applicationId: Store.getters.getPacketConfig?.appConfig?.sid,
        address,
        message,
        signature,
        app: "web",
      })
      callback(params)
    }, item);
    return;
  }

  callback(info);
};

const loginTypes = {
  particle_network: "THIRD_LOGIN_TYPE_PARTICLE_NETWORK",
  quick_login: "THIRD_LOGIN_TYPE_QUICK_LOGIN",
  telegram: "THIRD_LOGIN_TYPE_TELEGRAM",
  metamask: "THIRD_LOGIN_TYPE_METAMASK",
};
// 三方登陆统一方法
export const thirdLogin = async (item, eid) => {
  // 粒子网络
  if (item.loginType === "particle_network") {
    loginWithParticleFun(item);
  }
  // 快速登陆
  if (item.loginType === "quick_login") {
    quickLogin(item);
  }
  // telegram
  if (item.loginType === "telegram") {
    telegramLoginAuth(telegramLogin, item);
  }
  // metamask
  if (item.loginType === "metamask") {
    metamaskAuth(metamaskLogin, item);
  }

  if (eid && loginTypes[item.loginType]) {
    vm.$eventPost("click", {
      eid,
      time: Date.now(),
      type: loginTypes[item.loginType],
    });
  }
};

// 三方登陆sdk初始化 类型 loginType  子类型 loginSubType  配置参数 params
export const thirdLoginInit = async (data) => {
  console.log("thirdLoginInit", data.loginConfig?.thirdLoginList);
  const thirdLoginList = data.loginConfig?.thirdLoginList || [];
  if (!thirdLoginList?.length) {
    return;
  }
  thirdLoginList?.map(async (item) => {
    let params = {};
    try {
      params = JSON.parse(item.params);
    } catch (error) {
      params = {};
    }

    // 初始化粒子网络sdk
    if (item.loginType === "particle_network" && !particleNum && !particle) {
      particleNum = true;
      initParticle(params);
    }
    // // 初始化粒子网络sdk
    // if (item.loginType === "particle_network" && !connectKitNum && !connectKit) {
    //   connectKitNum = true;
    //   initConnectKit(params);
    // }

    // 初始化telegram sdk
    if (item.loginType === "telegram") {
      window.telegram_key = params.bot_token;
      (function (d, s, w) {
        var tjs1;
        const script = d.getElementsByTagName(s)[0];
        tjs1 = d.createElement(s);
        tjs1.async = true;
        tjs1.defer = true;
        tjs1.src = "https://telegram.org/js/telegram-widget.js";
        tjs1.onload = w.gapiLoaded;
        script.parentNode.insertBefore(tjs1, script);
      })(document, "script", window);
    }

    // 初始化metamask sdk
    if (item.loginType === "metamask") {
      // initMetamask();
    }
  });
};


const icons = {
  phone: require("@/lobby_common/assets/login/dl_shouji.png"),
  account: require("@/lobby_common/assets/login/dl_zhanghao.png"),
  email: require("@/lobby_common/assets/login/dl_youxiang.png"),
  facebook: require("@/lobby_common/assets/login/dl_facebook.png"),
  google: require("@/lobby_common/assets/login/dl_google.png"),
  telegram: require("@/lobby_common/assets/login/dl_telegram.png"),
  metamask: require("@/lobby_common/assets/login/dl_MetaMask.png"),
  tron: require("@/lobby_common/assets/login/dl_tron.png"),
  quick_login: require("@/lobby_common/assets/login/dl_yijiandl.png"),
  apple: require("@/lobby_common/assets/login/dl_apple.png"),
  twitter: require("@/lobby_common/assets/login/dl_twitter.png"),
  linkedin: require("@/lobby_common/assets/login/dl_linkedin.png"),
  discord: require("@/lobby_common/assets/login/dl_discord.png"),
  walletconnect: require("@/lobby_common/assets/login/dl_WalletConnect.png"),
  keplr: require("@/lobby_common/assets/login/dl_Keplr.png"),
  line: require("@/lobby_common/assets/login/dl_Line.png"),
  phantom: require("@/lobby_common/assets/login/dl_Phantom.png"),
};
export const getLoginIcon = (item) => {
  return icons[item.type];
}